import { Component, input, output } from '@angular/core';

export type ButtonVariant = 'primary' | 'secondary' | 'light' | 'red-light' | 'red-dark' | 'no-borders';
export type ButtonSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-button',
  template: `
    <button 
      [class]="buttonClasses()"
      [disabled]="disabled()"
      (click)="buttonClick.emit($event)"
      [type]="type()">
      <ng-content></ng-content>
    </button>
  `,
  styles: [`
    :host {
      display: inline-block;
    }
  `]
})
export class ButtonComponent {
  // Inputs
  readonly variant = input<ButtonVariant>('primary');
  readonly size = input<ButtonSize>('medium'); 
  readonly disabled = input<boolean>(false);
  readonly type = input<'button' | 'submit' | 'reset'>('button');
  readonly fullWidth = input<boolean>(false);

  // Outputs
  readonly buttonClick = output<MouseEvent>();

  protected buttonClasses(): string {
    const classes = ['btn'];
    
    // Add variant class
    switch (this.variant()) {
      case 'primary':
        classes.push('btn-primary-supervin');
        break;
      case 'secondary':
        classes.push('btn-supervin-light');
        break;
      case 'light':
        classes.push('btn-light');
        break;
      case 'red-light':
        classes.push('btn-red-light');
        break;
      case 'red-dark':
        classes.push('btn-red-dark');
        break;
      case 'no-borders':
        classes.push('btn-supervin-light', 'btn-no-borders');
        break;
    }

    // Add size class
    switch (this.size()) {
      case 'small':
        classes.push('btn-sm');
        break;
      case 'large':
        classes.push('btn-lg');
        break;
      // medium is default, no extra class needed
    }

    // Add full width if needed
    if (this.fullWidth()) {
      classes.push('w-100');
    }

    return classes.join(' ');
  }
}
